import { Nav } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectBoardData, setBoardData } from "../../../redux/reducer/board/boardSlice";

//-------------------------------------------------------------------
export default function AgreeNavS() {
    //redux
    const dispatch = useAppDispatch();
    const data = useAppSelector(selectBoardData);

    //view
    return (
        <Nav.Item>
            <Nav.Link
                active={data === "agreeS"}
                eventKey="agreeS-link"
                onClick={() => {
                    dispatch(setBoardData("agreeS"));
                }}
            >
                Umowy skupu
            </Nav.Link>
        </Nav.Item>
    );
}
